import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const ExpertChat = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default ExpertChat;
